import React, { useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import IconShoppingCart from 'cccisd-icons/cart';
import IconLeftArrow from 'cccisd-icons/arrow-left6';
import { NavLink } from 'cccisd-react-router';

import style from './style.css';
import logo3c from './3CI_symbol.svg';
import wpUrl from '../../../../helpers/wpUrl';
import navLinks, { courseProgress } from './navLinks';

const Fortress = window.cccisd.fortress;

function ProductHeader(props) {
    const actingRole = Fortress.user.acting.role.handle;
    const [size, setSize] = useState(() => window.innerWidth);
    useEffect(() => {
        const calcInnerWidth = _debounce(() => {
            setSize(window.innerWidth);
        }, 200);

        window.addEventListener('resize', calcInnerWidth);

        return () => {
            window.removeEventListener('resize', calcInnerWidth);
        };
    }, []);

    // 768 is hardcoded in cccisd-header, so lets match it to that
    const isMobile = size < 768;

    const { product } = props;
    const primaryNavLinks = [
        {
            url: '/products',
            handle: '3cproducts',
            label: (
                <span>
                    <IconLeftArrow spaceRight /> Return to{' '}
                    <img className={style.logo3c} src={logo3c} alt="3C Institute" /> Products
                </span>
            ),
        },
    ];

    let secondaryNavLinks = Object.values(navLinks);
    switch (actingRole) {
        case 'instructor':
            if (!['ssgrin_ec', 'ssgrin_k2', 'ssgrin_35'].includes(product.handle)) {
                secondaryNavLinks = secondaryNavLinks.filter(
                    navLink => navLink.handle === 'training' || navLink.handle === 'resources'
                );
            }
            break;
        case 'siteAdmin':
        case 'orgAdmin':
            secondaryNavLinks = secondaryNavLinks.filter(
                navLink =>
                    navLink.handle === 'training' || navLink.handle === 'resources' || navLink.handle === 'manage'
            );

            if (!['ssgrin_ec', 'ssgrin_k2', 'ssgrin_35'].includes(product.handle)) {
                const manageIndex = secondaryNavLinks.findIndex(n => n.handle === 'manage');
                secondaryNavLinks[manageIndex].url = '/product/:productHandle/managePartial';
            } else if (actingRole === 'orgAdmin') {
                secondaryNavLinks.splice(2, 0, courseProgress);
            }
            break;
        case 'supervisor':
            secondaryNavLinks = secondaryNavLinks.filter(
                navLink => navLink.handle === 'training' || navLink.handle === 'resources'
            );
            break;
        default:
            break;
    }

    const logoContentClassName = `cccisd${product.handle}`;

    // add product handle to secondary nav links
    secondaryNavLinks = secondaryNavLinks.map(link => {
        if (product.handle === 'ssgrin_ec') {
            link.url = link.url.replace(/dashboard$/i, 'dashboardEC');
        }

        return {
            ...link,
            url: link.url.replace(':productHandle', product.handle),
        };
    });

    return (
        <>
            <Header
                additionalIconLinks={[
                    {
                        icon: IconShoppingCart,
                        url: wpUrl + '/cart',
                        handle: 'cart',
                    },
                ]}
                isDarkPrimaryNav
                logoClassName={`${style.logo} ${logoContentClassName}`}
                logoLink={null}
                primaryNavLinks={primaryNavLinks}
                {...(isMobile ? { secondaryNavLinks } : {})}
                showAdminAction={false}
                showHomeAction={false}
                wrapperClassName={style.primary}
            />

            {/* Custom secondary nav */}
            {!isMobile && (
                <div className={'container ' + style.secondary}>
                    {secondaryNavLinks.map(link => {
                        const Icon = link.icon;

                        return (
                            <NavLink key={link.handle} to={link.url}>
                                <Icon spaceRight />
                                {link.label}
                            </NavLink>
                        );
                    })}
                </div>
            )}

            {/* cannot set pseudo class names using Javascript,
             * so let's use direct css
             */}
            <style>{`
                .${logoContentClassName}:before {
                    content: "${product.label}";
                }
            `}</style>
        </>
    );
}

ProductHeader.propTypes = {
    product: PropTypes.object,
};

export default ProductHeader;
